import { T as TolgeeT } from "@tolgee/react";

import { ITranslateProps } from "../types";

export const T = (props: ITranslateProps) => {
  return (
    <TolgeeT
      params={props.params}
      keyName={props.keyName}
      defaultValue={props.defaultValue}
    />
  );
};
